import React from "react";
import { Inbox } from "lucide-react";
import { Card, CardContent } from "../ui/card";
import { Button } from "../ui/button";

const EmptyState = ({ icon = <Inbox />, title, subtitle, actionLabel, onAction }) => {
    return (
        <Card>
            <CardContent className="flex flex-col items-center text-center py-12 px-6">
                <div className="w-12 h-12 text-muted-foreground mb-4">
                    {icon}
                </div>
                <h3 className="text-lg font-semibold text-foreground">
                    {title}
                </h3>
                <p className="text-sm text-muted-foreground mt-1">
                    {subtitle}
                </p>
                {actionLabel && onAction && (
                    <Button variant="outline" className="mt-4" onClick={onAction}>
                        {actionLabel}
                    </Button>
                )}
            </CardContent>
        </Card>
    );
};

export default EmptyState;
